const bbCommon = function(){
	const bbFirstName = document.getElementById("FirstName");
	const bbLastName = document.getElementById("LastName");
	const bbCompany = document.getElementById("companyDisplay");
	const bbAddress1 = document.getElementById("addr1Display");
	const bbAddress2 = document.getElementById("addr2Display");
	const bbAddress3 = document.getElementById("addr3Display");
	const bbCity = document.getElementById("cityDisplay");
	const bbState = document.getElementById("stateDisplay");
	const bbZip = document.getElementById("zipcodeDisplay");
	const bbID = document.getElementById("BoxID");
	const bbEndDate = document.getElementById("EndDate");
	const bbCampaignID = document.getElementById("CampaignID");
	const bbCustContactID = document.getElementById("CustomerContactID");
	const bbCustID = document.getElementById("CustomerID");
	
	const bbModel = { //oBoxModel
		FirstName: bbFirstName ? bbFirstName.value : "",
		LastName: bbLastName ? bbLastName.value : "", 
		Company: bbCompany ? bbCompany.textContent : "",
		Address1:  bbAddress1 ? bbAddress1.textContent : "",
		Address2: bbAddress2 ? bbAddress2.textContent : "",
		Address3: bbAddress3 ? bbAddress3.textContent : "",
		City: bbCity ? bbCity.textContent : "",
		State: bbState ? bbState.textContent : "",
		ZipCode: bbZip ? bbZip.textContent : "",
		BoxID: bbID ? parseInt(bbID.value) : null,
		EndDate: bbEndDate ? bbEndDate.value : "",
		CampaignID: bbCampaignID ? parseInt(bbCampaignID.value) : null,
		CustomerContactID: bbCustContactID ? parseInt(bbCustContactID.value) : null,
		CustomerID: bbCustID ? parseInt(bbCustID.value) : null
	};
	const headerToken = document.querySelectorAll('input[name=__RequestVerificationToken]')[0] ? document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value : "";

	const displayStatusMsg = () => {
		const bbHeader = document.getElementById("bbHeader");
		const statusMsg = '<div id="bbStatus" class="c-md-5 c-sm-quarter-3 c-xs-full"><p class="inlineMiddle marginTop20 padding15 textRed textSemiBold text16 borderDkRed" role="status">We were unable to process your request. Please refresh the page and try again.</p></div>';
		bbHeader.insertAdjacentHTML("afterend", statusMsg);
		window.scrollTo({ top: 0, behavior: "smooth" });
	};
	
	const fixBoxModel = (bbModel) => {
		bbModel.EndDate = new Date(bbModel.EndDate);
		bbModel.AltBoxesSeen = bbModel.AltBoxesSeen ? bbModel.AltBoxesSeen.toString().toLowerCase() == "true" : false;
		bbModel.NoBox = bbModel.NoBox ? bbModel.NoBox.toString().toLowerCase() == "true" : false;
		bbModel.IsCrosslandBox = bbModel.IsCrosslandBox ? bbModel.IsCrosslandBox.toString().toLowerCase() == "true" : false;
		bbModel.IsBoxSuggestionActive = bbModel.IsBoxSuggestionActive ? bbModel.IsBoxSuggestionActive.toString().toLowerCase() == "true" : false;
		bbModel.ShowAddress3 = bbModel.ShowAddress3 ? bbModel.ShowAddress3.toString().toLowerCase() == "true" : false;
	};
	
	const updateA11yStatus = (text) => {
		const submitStatus = document.querySelector(".submitStatus");
		const submitResults = document.querySelector(".submitResults");
		const status = '<p class="submitStatus visually-hidden" role="alert" aria-atomic="true">' + text + '</p>';
		if(submitStatus) submitStatus.remove();
		submitResults.insertAdjacentHTML("afterbegin", status);
	};
	
	const getVisibleLink = (section) => {
		let visibleLinks = [];
		const allLinks = section.querySelectorAll("a");
		for(let i = 0; i < allLinks.length; i++){
			if(allLinks[i].offsetParent !== null) visibleLinks.push(allLinks[i]);
		}
		return visibleLinks[0];
	};

	const enableBlueBtn = (btn) =>{
		btn.disabled = false;
		btn.classList.add("bkgdBlue");
		btn.classList.remove("disabledBtn");
		btn.classList.remove("textDarkestGray");
	};

	const disableBlueBtn = (btn) => {
		btn.disabled = true;
		btn.classList.remove("bkgdBlue");
		btn.classList.add("disabledBtn");
		btn.classList.add("textDarkestGray");
	};
	
	const removeStatusMsg = () => {
		const bbStatus = document.getElementById("bbStatus");
		if(bbStatus) bbStatus.remove();
	};
	
	const getAltBoxIDs = () =>{
		const altBoxRadioButtons = document.getElementsByClassName("altBoxRadio");
		if (altBoxRadioButtons.length) {
			bbModel.AltBoxOptions = [];
			for (let i = 0; i < altBoxRadioButtons.length; i++) {
				bbModel.AltBoxOptions.push({ "BoxID" : altBoxRadioButtons[i].value });
			}
		}
	};
	
	const omnitureLogBtn = () => {
		return {
			BtnPushed: (buttonID) => {
				if (!s) {
					console.error('s not available. Using fallback');
				}
				
		           	let account = (s && typeof s.account === 'string') ? s.account : '4imprintprod';
		           	
		           	//initialize the Adobe Analytics object z using s_gi(account) 
	            		let z = typeof s_gi === 'function' ? s_gi(account) : null;
	
		                if (z) {
		                    z.linkTrackVars = 'eVar27,events';
		                    z.linkTrackEvents = 'event24';
		                    z.eVar27 = buttonID;
		                    z.events = 'event24';
		                    z.tl(this, 'o', 'Bluebox Links');
		                } else {
		                    console.warn('Adobe Analytics object is not initialized. Event tracking skipped.');
		                }
		       }
	       }
	};
	
	const displayCookieMsg = () => {
		const bbHead = document.getElementById("bbHeader");
		bbHead.insertAdjacentHTML("afterend", '<div id="bbStatus" class="c-md-5 c-sm-quarter-3 c-xs-full"><p class="inlineMiddle marginTop20 padding15 textRed textSemiBold text16 borderDkRed" role="status">We were unable to process your request. Please refresh the page and try again. If you continue to receive this message, please be sure you have cookies enabled and no extensions or browser settings are blocking the use of cookies.</p></div>');
		window.scrollTo({ top: 0, behavior: "smooth" });
	};
	
	const resetInvalidFields = () =>{
		const invalidFields = [].slice.call(document.querySelectorAll(".input-validation-error"));
		for(let i = 0; i < invalidFields.length; i++){
			invalidFields[i].classList.remove("input-validation-error");
        		invalidFields[i].setAttribute("aria-invalid", "false");
		}

        	const errorMessages = document.getElementsByClassName("errorMessage");
        	for (let i = 0; i < errorMessages.length; i++) {
        		errorMessages[i].classList.add("hide");
        	}
        	
        	const errorBox = document.getElementById("ErrorBox");
        	const editError = document.getElementById("editAddressError");
        	if(errorBox) errorBox.remove();
        	if (editError) editError.innerHTML = "";
	};
	
	const showSuggestion = (e) => {
		if(e) e.preventDefault();
		resetInvalidFields();
		const altBoxOptions = document.getElementById("altBoxOptions");
		if (altBoxOptions) {
			altBoxOptions.classList.add("opaque");
			const altBtns = document.getElementById("altBoxButtons");
			altBtns.classList.add("hide");
			const altBoxRadioButtons = document.getElementsByClassName("altBoxRadio");
			if (altBoxRadioButtons) {
				for (let i = 0; i < altBoxRadioButtons.length; i++) {
					altBoxRadioButtons[i].disabled = true;
				}
			}
		}
		const boxSuggestion = document.getElementById("boxSuggestion");
		const suggestionInput = document.getElementById("bbSuggestion");
		boxSuggestion.classList.remove("hide");
        	suggestionInput.focus();
	};
	
	const displayFormSections = (response) => {
		const mainForm = document.getElementsByClassName("mainForm")[0];
		const boxResult = document.getElementsByClassName("boxResult")[0];
		const errorMessage = document.getElementsByClassName("clickErrorMessage")[0];
		
		if (mainForm) mainForm.classList.add("hide");
			
		if (response.model.Result != null && response.model.Result != "" && boxResult) {
			const accepted = document.getElementsByClassName("accepted")[0];
			const acceptedBox = response.model.Result == "accepted";
			const declinedBox = response.model.Result == "declined";
			const suggestedBox = response.model.Result == "suggested";
			const acceptedFriendBox = response.model.Result == "acceptedFriend";
			const declinedFriendBox = response.model.Result == "declinedFriend";
			const addressResult = document.getElementById("resultAddressInfo");

			boxResult.classList.remove("hide");
			errorMessage.classList.add("hide");
			
			if (acceptedBox || declinedFriendBox) {
				accepted.classList.remove("hide");
				addressResult.classList.remove("hide");
				updateA11yStatus("Thank you, your Blue Box is on the way.");
			} else if (acceptedFriendBox) {
				const acceptedFriend = document.getElementsByClassName("acceptedFriend")[0];
				accepted.classList.remove("hide");
				acceptedFriend.classList.remove("hide");
				addressResult.classList.remove("hide");
				updateA11yStatus("Thank you, your Blue Box is on the way.");
			} else if (suggestedBox) {
				const suggested = document.getElementsByClassName("suggested")[0];
				suggested.classList.remove("hide");
				updateA11yStatus("Thank you for your feedback.");
			} else if (declinedBox) {
				const declined = document.getElementsByClassName("declined")[0];
				declined.classList.remove("hide");
				updateA11yStatus("Your Blue Box has been skipped.");
			}
		} else if ((response.model.Result == null || response.model.Result == "") && response.model.ShareableBoxID == 0) {
			boxResult.classList.remove("hide");
			errorMessage.classList.remove("hide");
		}
		
		const bbHeader = document.querySelector(".bbHeaderText h1");
		if (response.model.HeaderMessage != null && response.model.HeaderMessage.trim() != "") bbHeader.innerHTML = response.model.HeaderMessage;
		window.scrollTo({ top: 0, behavior: "smooth" });
		
		// find first link in this section that isn't hidden and set focus for a11y
		const results = document.querySelector(".submitResults");
		const firstLink = getVisibleLink(results);
		firstLink.focus();
	};
	
	return{
		bbModel: bbModel,
		HeaderToken: headerToken,
		FixBoxModel: fixBoxModel,
		UpdateA11yStatus: updateA11yStatus,
		GetVisibleLink: getVisibleLink,
		EnableBlueBtn: enableBlueBtn,
		DisableBlueBtn: disableBlueBtn,
		RemoveStatusMsg: removeStatusMsg,
		DisplayFormSections: displayFormSections,
		DisplayStatusMsg: displayStatusMsg, 
		GetAltBoxIDs: getAltBoxIDs, 
		OmnitureLogBtn: omnitureLogBtn,
		DisplayCookieMsg: displayCookieMsg, 
		ResetInvalidFields: resetInvalidFields, 
		ShowSuggestion: showSuggestion
	};
}